import React, {
  createContext,
  useContext,
  useLayoutEffect,
  useState,
} from "react"
import { useParams, useRouteMatch } from "react-router-dom"

import { webClientConfig } from "@shared/apis"
import { getParam, kick } from "@shared/modules"
import { accountService } from "@shared/services"

import firebase from "firebase"

const initAccount = {
  viewer: null,
  currentUser: null,
}

const accountContext = createContext<ContextProps>({
  account: initAccount,
  setAccount: () => {},
})

interface Props {
  children: React.ReactNode
}

function AccountProvider({ children }: Props) {
  const { scheduleId } = useParams<{ scheduleId?: string }>()
  const [account, setAccount] = useState<Account>(initAccount)
  const isVodOrShortsPlayer = !!useRouteMatch({
    path: [
      "/:streamerName/:scheduleId/vods",
      "/:streamerName/:scheduleId/shorts/:shortsId",
    ],
    sensitive: true,
    strict: true,
    exact: true,
  })

  useLayoutEffect(() => {
    if (!scheduleId) {
      kick("잘못된 접근 입니다.")
    }
    webClientConfig.scheduleId = scheduleId

    accountService.signing(
      scheduleId,
      setAccount,
      getParam("ticket", ""),
      getParam("username"),
      getParam("is_only_player"),
      getParam("partner_id"),
      isVodOrShortsPlayer,
      getParam("otp"),
    )
  }, [scheduleId, isVodOrShortsPlayer])

  const contextValue = {
    account,
    setAccount,
  }

  return (
    <accountContext.Provider value={contextValue}>
      {children}
    </accountContext.Provider>
  )
}

function useAccount() {
  return useContext(accountContext)
}

export { AccountProvider, accountContext, useAccount }

interface ContextProps {
  account: Account
  setAccount: React.Dispatch<React.SetStateAction<Account>>
}

export type Account = {
  viewer: Viewer | null
  currentUser: firebase.User | null
}

export type Viewer = {
  userId: number | string | undefined
  nickname: string
  username: string
  role: Role
  timestamp: number | undefined
  isKicked?: boolean
  isBlockedChat: boolean
  device: string
  uuid: string | undefined
}

export type Role =
  | "SYSTEM"
  | "ADMIN"
  | "USER"
  | "STREAMER"
  | "FREE_USER"
  | "PAID_USER"
  | "OTHER_PAID_USER"
  | "NOT_MATCHED_USER"
  | "MANAGER"
  | "HELPER"
  | "PARTNER"
  | "ANONYMOUS"
